import React, { useState, useEffect, useRef } from "react";
import { TipoControl } from "enum";
import { useAtom } from "jotai";
import {
	componentSelectedAtom,
	signatureModalVisibleAtom,
	signaturesMetadataAtom,
	visibilidadComponentesAtom,
} from "../../MisDocumentosMovilStorage";
import { Input, Button, DatePicker } from "antd";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import { UploadOutlined } from "@ant-design/icons";
import { SignaturePerson } from "components/common/VisorFormulario/constantes";
import produce from "immer";
import html2canvas from "html2canvas";
import moment from "moment";
import { useContext } from "react";
import { SecurityContext } from "context/SecurityContextProvider";
import { UbigeoService } from "services";

export const ControlPdf = ({ componente, componentes, variables, datosFormulario, urlFirmaHolografa, urlHuellaDactilar }) => {
	const {
		control,
		setValue,
		getValues,
		register,
		unregister,
		formState: { errors },
	} = useFormContext();
	const [, setSignatureModalVisible] = useAtom(signatureModalVisibleAtom);
	const [, setComponentSelected] = useAtom(componentSelectedAtom);
	const [signaturesMetadata, setSignaturesMetadata] = useAtom(signaturesMetadataAtom);
	const [visibilidadComponentes, setVisibilidadComponentes] = useAtom(visibilidadComponentesAtom);
	const [signature, setSignature] = useState(undefined);
	const [imagen, setImagen] = useState(undefined);

	const { getUsuarioAutenticado } = useContext(SecurityContext);
	//const isExplomin = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20501523837" ? true : false;

	// Mapa de componentes por key/name, usado por debeOcultarseComponente para subir recursivamente
	// por la cadena de controles padre.
	const componentesMap = React.useMemo(() => {
		const map = {};
		if (componentes && Array.isArray(componentes)) {
			componentes.forEach((c) => {
				if (c.type === TipoControl.RADIO_BUTTON) {
					map[c.name] = c;
				} else {
					map[c.key] = c;
				}
			});
		}
		return map;
	}, [componentes]);

	const watchControl = useWatch({
		control,
		name: componente.type === TipoControl.RADIO_BUTTON ? componente.name : componente.key,
	});

	useEffect(() => {
		if (componente.type === TipoControl.RADIO_BUTTON && watchControl !== "") {
			setVisibilidadComponentes({ ...visibilidadComponentes, [componente.name]: watchControl });
		} else if (componente.type === TipoControl.CHECKBOX && watchControl !== "") {
			const valor = watchControl !== "" && watchControl !== undefined ? "checked" : undefined;
			setVisibilidadComponentes({ ...visibilidadComponentes, [componente.key]: valor });
		} else if (componente.type === TipoControl.LISTA && watchControl !== "") {
			setVisibilidadComponentes({ ...visibilidadComponentes, [componente.key]: watchControl });
		}
	}, [watchControl]);

	const valorControlValidacionLongitud = useWatch({
		control,
		name: componente.validacionLongitud?.control || componente.key,
	});
	const reglaLongitudActiva = componente.validacionLongitud?.reglas?.find(
		(regla) => regla.valor === valorControlValidacionLongitud
	);
	const esExcepcionValidacionLongitud = componente.validacionLongitud?.excepciones?.includes(
		valorControlValidacionLongitud
	);
	const reglaLongitudEfectiva =
		reglaLongitudActiva ||
		(!esExcepcionValidacionLongitud ? componente.validacionLongitud?.reglaPorDefecto : undefined);

	useEffect(() => {
		const cargarHuellaDactilar = () => {
			if (
				urlHuellaDactilar &&
				componente.type === TipoControl.IMAGEN &&
				componente.defaultValue === "HUELLA_DACTILAR"
			) {
				fetch(urlHuellaDactilar)
					.then((response) => response.blob())
					.then((blob) => {
						const reader = new FileReader();
						reader.readAsDataURL(blob);
						reader.onload = () => {
							setValue(nombreControl, reader?.result);
							setImagen({
								key: componente.key,
								base64: reader.result,
							});
						};
					})
					.catch((error) => {
						console.log("no se pudo cargar la huella dactilar", error);
					});
			}
		};
		cargarHuellaDactilar();
	}, [urlHuellaDactilar]);

	useEffect(() => {
		const cargarFirmaHolografa = () => {
			if (
				urlFirmaHolografa &&
				componente.type === TipoControl.SIGNATURE &&
				componente.signaturePerson === SignaturePerson.COLABORADOR
			) {
				fetch(urlFirmaHolografa)
					.then((response) => response.blob())
					.then((blob) => {
						const reader = new FileReader();
						reader.readAsDataURL(blob);
						reader.onload = () => {
							setSignaturesMetadata(
								produce((draft) => {
									const signature = draft.find((s) => s.key === componente.key);
									if (signature) {
										signature.base64 = reader.result;
									} else {
										draft.push({
											key: componente.key,
											base64: reader.result,
										});
									}
								})
							);
						};
					})
					.catch((error) => {
						console.log("no se pudo cargar la url de firma hológrafa", error);
					});
			}
		};

		cargarFirmaHolografa();
	}, [urlFirmaHolografa]);

	const getNombreControl = () => {
		let nombreControl = componente.key;
		if (componente.groupBy) {
			nombreControl = `${componente.groupBy.table}.${componente.groupBy.rowNumber - 1}.${componente.groupBy.column
				}`;
		} else {
			if (componente.type === TipoControl.RADIO_BUTTON) {
				nombreControl = componente.name;
			} else if (componente.type === TipoControl.SIGNATURE) {
				nombreControl = componente.key + "_signature_base64";
			} else if (componente.type === TipoControl.IMAGEN) {
				nombreControl = componente.key + "_imagen_base64";
			} else {
				nombreControl = componente.key;
			}
		}
		return nombreControl;
	};

	const getClassName = (nombreControl) => {
		let className = "";
		if (errors) {
			if (componente.type === TipoControl.CAJA_TEXTO) {
				if (componente.groupBy) {
					className = "formulario-input";
					const errores = errors[componente.groupBy.table];
					if (
						errores &&
						errores[componente.groupBy.rowNumber - 1] &&
						errores[componente.groupBy.rowNumber - 1][componente.groupBy.column]
					) {
						className = "formulario-input-error";
					}
				} else {
					className = errors[nombreControl] ? "formulario-input-error" : "formulario-input";
				}
			} else if (componente.type === TipoControl.LISTA) {
				if (componente.groupBy) {
					className = "formulario-list";
					const errores = errors[componente.groupBy.table];
					if (
						errores &&
						errores[componente.groupBy.rowNumber - 1] &&
						errores[componente.groupBy.rowNumber - 1][componente.groupBy.column]
					) {
						className = "formulario-list-error";
					}
				} else {
					className = errors[nombreControl] ? "formulario-list-error" : "formulario-list";
				}
			} else if (componente.type === TipoControl.CHECKBOX) {
				if (componente.groupBy) {
					className = "formulario-control-container";
					const errores = errors[componente.groupBy.table];
					if (
						errores &&
						errores[componente.groupBy.rowNumber - 1] &&
						errores[componente.groupBy.rowNumber - 1][componente.groupBy.column]
					) {
						className = "formulario-control-container-error";
					}
				} else {
					className = errors[nombreControl]
						? "formulario-control-container-error"
						: "formulario-control-container";
				}
			} else if (componente.type === TipoControl.RADIO_BUTTON) {
				if (componente.groupBy) {
					className = "formulario-control-container";
					const errores = errors[componente.groupBy.table];
					if (
						errores &&
						errores[componente.groupBy.rowNumber - 1] &&
						errores[componente.groupBy.rowNumber - 1][componente.groupBy.column]
					) {
						className = "formulario-control-container-error";
					}
				} else {
					className = errors[nombreControl]
						? "formulario-control-container-error"
						: "formulario-control-container";
				}
			} else if (componente.type === TipoControl.SIGNATURE) {
				className = errors[nombreControl] ? "formulario-signature-button-error" : "formulario-signature-button";
			} else if (componente.type === TipoControl.IMAGEN) {
				className = errors[nombreControl] ? "formulario-file-error" : "formulario-file";
			} else if (componente.type === TipoControl.FECHA) {
				className = errors[nombreControl] ? "formulario-input-error" : "formulario-input";
			}
		}
		return className;
	};

	let nombreControl = getNombreControl();
	let className = getClassName(nombreControl);

	const estaOculto = React.useMemo(
		() => debeOcultarseComponente(componente, visibilidadComponentes, componentesMap),
		[componente, visibilidadComponentes, componentesMap]
	);

	// Al ocultarse (ej. cambia el radiobutton/lista del que depende), hay que dar de baja el valor
	// del campo en react-hook-form (unregister), no solo dejar de renderizarlo: sin esto, el valor
	// anterior queda registrado igual y se envía junto con los datos del grupo recién mostrado.
	useEffect(() => {
		if (estaOculto && componente.type !== TipoControl.SIGNATURE) {
			unregister(nombreControl);
		}
	}, [estaOculto]);

	const valorControlPadreUbigeo = useWatch({
		control,
		name: componente.fuenteDatosLista?.control || componente.key,
	});
	const [opcionesUbigeo, setOpcionesUbigeo] = useState([]);
	const valorControlPadreUbigeoRef = useRef(valorControlPadreUbigeo);

	useEffect(() => {
		const cargarOpcionesUbigeo = async () => {
			const tipo = componente.fuenteDatosLista?.tipo;
			if (!tipo) {
				return;
			}
			try {
				if (tipo === "DEPARTAMENTO") {
					const departamentos = await UbigeoService.listarDepartamentos();
					setOpcionesUbigeo((departamentos || []).map((d) => ({ key: d.nombre, value: d.nombre })));
				} else if (tipo === "PROVINCIA") {
					if (!valorControlPadreUbigeo) {
						setOpcionesUbigeo([]);
						return;
					}
					const formData = new FormData();
					formData.append("departamento", valorControlPadreUbigeo);
					const provincias = await UbigeoService.listarProvincias(formData);
					setOpcionesUbigeo((provincias || []).map((p) => ({ key: p.provincia, value: p.provincia })));
				} else if (tipo === "DISTRITO") {
					if (!valorControlPadreUbigeo) {
						setOpcionesUbigeo([]);
						return;
					}
					const formData = new FormData();
					formData.append("provincia", valorControlPadreUbigeo);
					const distritos = await UbigeoService.listarDistritos(formData);
					setOpcionesUbigeo(
						(distritos || [])
							.map((d) => ({ key: d.distrito, value: d.distrito }))
							.sort((a, b) => a.value.localeCompare(b.value, "es"))
					);
				}
			} catch (error) {
				console.log("no se pudo cargar las opciones de ubigeo", error);
			}
		};
		cargarOpcionesUbigeo();
	}, [componente.fuenteDatosLista?.tipo, valorControlPadreUbigeo]);

	useEffect(() => {
		if (
			componente.fuenteDatosLista?.control &&
			valorControlPadreUbigeoRef.current !== valorControlPadreUbigeo
		) {
			setValue(nombreControl, "");
		}
		valorControlPadreUbigeoRef.current = valorControlPadreUbigeo;
	}, [valorControlPadreUbigeo]);

	useEffect(() => {
		if (componente.type === TipoControl.SIGNATURE) {
			const signature = signaturesMetadata.find((s) => s.key === componente.key);
			setSignature(signature);
			setValue(nombreControl, signature?.base64);
		}
	}, [signaturesMetadata]);

	useEffect(() => {
		const loadSignature = async () => {
			if (componente.type === TipoControl.SIGNATURE) {
				if (componente.signatureType === "IMAGEN_Y_DESCRIPCION") {
					const divElement = document.getElementById("signature" + nombreControl);

					const scale = 2;
					const canvas = await html2canvas(divElement, { scale });

					const base64Image = canvas.toDataURL("image/png");

					if (base64Image !== "data:,") {
						setValue(nombreControl, base64Image);
					}
				}
			}
		};

		loadSignature();
	}, [signature]);

	const getMensajeRequerido = () => {
		if (componente.required && !componente.correlativo) {
			if (componente.groupBy) {
				return "El campo " + componente.label + " de la tabla " + componente.groupBy.table + " es requerido.";
			}
			return "El campo " + componente.label + " es requerido.";
		}
		return false;
	};

	const reglas = {
		required: getMensajeRequerido(),
	};

	// La regla depende del valor ACTUAL de otro control (ej. banco elegido en listaNombreBanco).
	// React Hook Form no re-registra minLength/maxLength declarativos cuando ese valor cambia
	// despues del primer render, por eso se evalua dentro de un validate() que lee getValues()
	// en el momento de validar (siempre al dia, nunca "congelado" en el valor inicial).
	if (componente.type === TipoControl.CAJA_TEXTO && componente.validacionLongitud) {
		reglas.validate = (value) => {
			const nombreControlLongitud = componente.validacionLongitud.control || componente.key;
			const valorControlLongitud = getValues(nombreControlLongitud);
			const reglaActiva = componente.validacionLongitud.reglas?.find(
				(regla) => regla.valor === valorControlLongitud
			);
			const esExcepcion = componente.validacionLongitud.excepciones?.includes(valorControlLongitud);
			const reglaEfectiva =
				reglaActiva || (!esExcepcion ? componente.validacionLongitud.reglaPorDefecto : undefined);
			if (!reglaEfectiva) {
				return true;
			}
			if (reglaEfectiva.requerido && !value) {
				return componente.groupBy
					? `El campo ${componente.label} de la tabla ${componente.groupBy.table} es requerido.`
					: `El campo ${componente.label} es requerido.`;
			}
			if (value && (value.length < reglaEfectiva.min || value.length > reglaEfectiva.max)) {
				return reglaEfectiva.min === reglaEfectiva.max
					? `El campo ${componente.label} debe tener ${reglaEfectiva.min} dígitos.`
					: `El campo ${componente.label} debe tener entre ${reglaEfectiva.min} y ${reglaEfectiva.max} dígitos.`;
			}
			return true;
		};
	}

	if (componente.type === TipoControl.CAJA_TEXTO && !reglaLongitudActiva) {
		if (componente.minLength) {
			reglas.minLength = {
				value: componente.minLength,
				message: `El campo ${componente.label} debe tener al menos ${componente.minLength} caracteres.`,
			};
		}
		if (componente.maxLength) {
			reglas.maxLength = {
				value: componente.maxLength,
				message: `El campo ${componente.label} debe tener como máximo ${componente.maxLength} caracteres.`,
			};
		}
	}

	if (componente.type === TipoControl.CAJA_TEXTO && componente.pattern) {
		reglas.pattern = {
			value: new RegExp(componente.pattern),
			message: componente.patternMessage || `El campo ${componente.label} tiene un formato inválido.`,
		};
	}

	var valorInicial = "";

	if (componente.type === TipoControl.CAJA_TEXTO) {
		valorInicial = "";
		if (componente.defaultValue) {
			if (componente.defaultValue === "${PERSONALIZADO}") {
				valorInicial = reemplazarVariables(componente.customDefaultValue, variables);
			} else if (componente.formatDefaultValue) {
				const fm = componente.formatDefaultValue.match(/^\$\{FECHA_ACTUAL([+-])(\d+)\}$/);
				if (fm) {
					const dias = parseInt(fm[2]);
					valorInicial = (fm[1] === '+' ? moment().add(dias, 'days') : moment().subtract(dias, 'days')).format('DD/MM/YYYY');
				} else {
					valorInicial = moment(variables[componente.defaultValue], "DD/MM/YYYY").format(
						componente.formatDefaultValue
					);
				}
			} else {
				valorInicial = variables[componente.defaultValue];
			}
		} else if (datosFormulario) {
			valorInicial = datosFormulario[componente.key];
		}

		if (estaOculto) {
			return "";
		}

		return (
			<Controller
				name={nombreControl}
				control={control}
				rules={reglas}
				defaultValue={valorInicial}
				render={({ field }) => (
					<Input
						className={className}
						style={{
							top: componente.overlay.top,
							left: componente.overlay.left,
							height: componente.overlay.height,
							width: componente.overlay.width,
							fontSize: "12px",
						}}
						readOnly={componente.readOnly || componente.correlativo}
						placeholder={componente.correlativo ? "Se asigna al firmar" : undefined}
						maxLength={
							reglaLongitudEfectiva?.max
								? reglaLongitudEfectiva.max
								: componente.maxLength && componente.maxLength > 0
								? componente.maxLength
								: undefined
						}
						{...field}
					/>
				)}
			/>
		);
	} else if (componente.type === TipoControl.LISTA) {
		var valorInicial = "";
		if (componente.defaultValue) {
			valorInicial = variables[componente.defaultValue];
		} else if (datosFormulario) {
			valorInicial = datosFormulario[componente.key];
		}

		if (estaOculto) {
			return "";
		}

		return (
			<Controller
				name={nombreControl}
				control={control}
				rules={reglas}
				defaultValue={valorInicial}
				render={({ field }) => (
					<select
						name="select"
						className={className}
						style={{
							top: componente.overlay.top,
							left: componente.overlay.left,
							height: componente.overlay.height,
							width: componente.overlay.width,
							fontSize: componente.overlay.height <= 12 ? "9px" : "12px",
						}}
						{...field}
					>
						<option value=""></option>
						{(componente.fuenteDatosLista?.tipo ? opcionesUbigeo : componente.items || []).map((item) => {
							return (
								<option key={item.key} value={item.key}>
									{item.value}
								</option>
							);
						})}
					</select>
				)}
			/>
		);
	} else if (componente.type === TipoControl.CHECKBOX) {
		var valorInicial = false;
		if (datosFormulario) {
			valorInicial = datosFormulario[componente.key] ? true : false;
		}

		if (estaOculto) {
			return "";
		}

		return (
			<Controller
				name={nombreControl}
				control={control}
				rules={reglas}
				render={({ field }) => (
					<div
						className={className}
						style={{
							top: componente.overlay.top,
							left: componente.overlay.left,
							height: componente.overlay.height,
							width: componente.overlay.width,
						}}
					>
						<input
							className="formulario-checkbox"
							type="checkbox"
							{...field}
							onChange={(e) => field.onChange(e.target.checked ? componente.value : undefined)}
						/>
					</div>
				)}
			/>
		);
	} else if (componente.type === TipoControl.RADIO_BUTTON) {
		// var valorInicial = "";
		// if (datosFormulario) {
		// 	valorInicial = datosFormulario[nombreControl];
		// }
		valorInicial = "";
		if (componente.defaultValue) {
			valorInicial = variables[componente.defaultValue]?.toUpperCase();
		} else if (datosFormulario) {
			valorInicial = datosFormulario[componente.name]?.toUpperCase();
		}

		if (estaOculto) {
			return "";
		}

		return (
			<Controller
				name={nombreControl}
				control={control}
				rules={reglas}
				render={({ field }) => (
					<div
						className={className}
						style={{
							top: componente.overlay.top,
							left: componente.overlay.left,
							height: componente.overlay.height,
							width: componente.overlay.width,
						}}
					>
						<input
							className="formulario-radio-button"
							type="radio"
							{...field}
							name={nombreControl}
							value={componente.value}
						/>
					</div>
				)}
			/>
		);
	} else if (componente.type === TipoControl.SIGNATURE) {
		const onClickBtnFirmar = () => {
			setComponentSelected(componente);
			//if (isExplomin) {
			//	setSignatureModalVisible(false);
			//}
			setSignatureModalVisible(true);
		};

		const isFirmaColaborador =
					componente.signaturePerson === SignaturePerson.COLABORADOR
					|| componente.signaturePerson === SignaturePerson.PERSONALIZADO
					|| componente.signaturePerson === null;
		return (
			<React.Fragment>
				<input {...register(nombreControl, reglas)} type="hidden" className="formulario-hidden" />
				<div
					id={"signature" + nombreControl}
					className="formulario-signature-container"
					style={{
						top: componente.overlay.top,
						left: componente.overlay.left,
						height: componente.overlay.height,
						width: componente.overlay.width,
						display: signature ? "flex" : "none",
						maxWidth: componente.overlay.width,
						maxHeight: componente.overlay.height,
					}}
					onClick={onClickBtnFirmar}
				>
					<img
						style={{
							flex: "1",
							width: isFirmaColaborador ? "100%" : "50%",
						}}
						src={signature?.base64}
					/>
					{!isFirmaColaborador && (
						<div
							style={{
								flex: "1",
								fontSize: "0.5em",
								display: "flex",
								justifyContent: "center",
								flexDirection: "column",
							}}
						>
							Firmado por: {getUsuarioAutenticado().nombreCompleto}
							<br />
							Fecha: {moment().format("DD/MM/YYYY")}
						</div>
					)}
				</div>
				<Button
					className={className}
					onClick={onClickBtnFirmar}
					style={{
						top: componente.overlay.top,
						left: componente.overlay.left,
						height: componente.overlay.height,
						width: componente.overlay.width,
						display: signature?.base64 ? "none" : "inherit",
					}}
				>
					<span style={{ fontWeight: "bold", fontSize: "12px" }}>Firmar aquí</span>
				</Button>
			</React.Fragment>

			// <React.Fragment>
			// 	<input {...register(nombreControl, reglas)} type="hidden" className="formulario-hidden" />
			// 	<div
			// 		className="formulario-signature-container"
			// 		style={{
			// 			top: componente.overlay.top,
			// 			left: componente.overlay.left,
			// 			height: componente.overlay.height,
			// 			width: componente.overlay.width,
			// 			display: signature ? "flex" : "none",
			// 		}}
			// 		onClick={onClickBtnFirmar}
			// 	>
			// 		<img src={signature?.base64} />
			// 	</div>
			// 	<Button
			// 		className={className}
			// 		onClick={onClickBtnFirmar}
			// 		style={{
			// 			top: componente.overlay.top,
			// 			left: componente.overlay.left,
			// 			height: componente.overlay.height,
			// 			width: componente.overlay.width,
			// 			display: signature?.base64 ? "none" : "inherit",
			// 		}}
			// 	>
			// 		<span style={{ fontWeight: "bold", fontSize: "12px" }}>Firmar aquí</span>
			// 	</Button>
			// </React.Fragment>
		);
	} else if (componente.type === TipoControl.IMAGEN) {
		const onChangeImagen = (e) => {
			if (e.target.files[0] !== undefined) {
				let reader = new FileReader();
				reader.readAsDataURL(e.target.files[0]);
				reader.onload = () => {
					setValue(nombreControl, reader?.result);
					setImagen({
						key: componente.key,
						base64: reader.result,
					});
				};
			}
		};

		if (estaOculto) {
			return "";
		}

		return (
			<React.Fragment>
				<input {...register(nombreControl, reglas)} type="hidden" className="formulario-hidden" />

				<label
					className={className}
					style={{
						top: componente.overlay.top,
						left: componente.overlay.left,
						height: componente.overlay.height,
						width: componente.overlay.width,
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						justifyContent: "center",
						cursor: "pointer",
					}}
				>
					{imagen?.base64 && (
						<img
							style={{
								top: componente.overlay.top,
								left: componente.overlay.left,
								height: componente.overlay.height,
								width: componente.overlay.width,
								display: imagen ? "flex" : "none",
							}}
							src={imagen?.base64}
						/>
					)}
					{!imagen?.base64 && (
						<React.Fragment>
							<UploadOutlined style={{ fontSize: "16px" }} />
							<span style={{ fontSize: "10px" }}>Subir imagen</span>
						</React.Fragment>
					)}
					<input style={{ display: "none" }} type="file" onChange={onChangeImagen} />
				</label>
			</React.Fragment>
		);
	} else if (componente.type === TipoControl.ETIQUETA) {
		valorInicial = "";
		if (componente.defaultValue) {
			if (componente.defaultValue === "${PERSONALIZADO}") {
				valorInicial = reemplazarVariables(componente.customDefaultValue, variables);
			} else if (componente.formatDefaultValue) {
				const fm = componente.formatDefaultValue.match(/^\$\{FECHA_ACTUAL([+-])(\d+)\}$/);
				if (fm) {
					const dias = parseInt(fm[2]);
					valorInicial = (fm[1] === '+' ? moment().add(dias, 'days') : moment().subtract(dias, 'days')).format('DD/MM/YYYY');
				} else {
					valorInicial = moment(variables[componente.defaultValue], "DD/MM/YYYY").format(
						componente.formatDefaultValue
					);
				}
			} else {
				valorInicial = variables[componente.defaultValue];
			}
		} else if (datosFormulario) {
			valorInicial = datosFormulario[componente.key];
		}

		if (estaOculto) {
			return "";
		}

		return (
			<Controller
				name={nombreControl}
				control={control}
				rules={reglas}
				defaultValue={valorInicial}
				render={({ field }) => (
					<Input.TextArea
						className="formulario-label"
						style={{
							top: componente.overlay.top,
							left: componente.overlay.left,
							height: componente.overlay.height,
							width: componente.overlay.width,
							fontSize: "12px",
							resize: 'none',
						}}
						readOnly={true}
						bordered={false}
						{...field}
					/>
				)}
			/>
		);
	} else if (componente.type === TipoControl.FECHA) {
		valorInicial = "";
		if (componente.defaultValue) {
			if (componente.defaultValue === "${PERSONALIZADO}") {
				valorInicial = reemplazarVariables(componente.customDefaultValue, variables);
			} else if (componente.formatDefaultValue) {
				const fm = componente.formatDefaultValue.match(/^\$\{FECHA_ACTUAL([+-])(\d+)\}$/);
				if (fm) {
					const dias = parseInt(fm[2]);
					valorInicial = (fm[1] === '+' ? moment().add(dias, 'days') : moment().subtract(dias, 'days')).format('DD/MM/YYYY');
				} else {
					valorInicial = moment(variables[componente.defaultValue], "DD/MM/YYYY").format(
						componente.formatDefaultValue
					);
				}
			} else {
				valorInicial = variables[componente.defaultValue];
			}
		} else if (datosFormulario) {
			valorInicial = datosFormulario[componente.key];
		}

		const disabledDate = (fecha) => {
			if (!componente.restringirFechaActual) return false;
			return !fecha.isSame(moment(), "day");
		};

		if (estaOculto) {
			return "";
		}

		return (
			<Controller
				name={nombreControl}
				control={control}
				rules={reglas}
				defaultValue={valorInicial}
				render={({ field }) => (
					<DatePicker
						className={className}
						style={{
							top: componente.overlay.top,
							left: componente.overlay.left,
							height: componente.overlay.height,
							width: componente.overlay.width,
							fontSize: "12px",
						}}
						format="DD/MM/YYYY"
						placeholder="dd/mm/aaaa"
						disabled={componente.readOnly}
						disabledDate={disabledDate}
						allowClear={!componente.required}
						value={field.value ? moment(field.value, "DD/MM/YYYY") : null}
						onChange={(fecha, fechaTexto) => field.onChange(fechaTexto)}
					/>
				)}
			/>
		);
	}

	return "";
};

function reemplazarVariables(texto, variables) {
	return texto.replace(/\$\{([^}]+)\}/g, (match, key) => {
		const fechaMatch = key.match(/^FECHA_ACTUAL([+-])(\d+)$/);
		if (fechaMatch) {
			const dias = parseInt(fechaMatch[2]);
			const fecha = fechaMatch[1] === '+'
				? moment().add(dias, 'days')
				: moment().subtract(dias, 'days');
			return fecha.format('DD/MM/YYYY');
		}
		if (variables.hasOwnProperty(match)) {
			return variables[match];
		}
		return match;
	});
}

// Soporta "accion": "show" (mostrarse solo si se cumple la condición) y "hidden" (ocultarse si se
// cumple), y sube recursivamente por la cadena de controles padre: si el control del que depende
// este componente está a su vez oculto, este componente también debe considerarse oculto, sin
// importar el último valor que haya quedado registrado para ese control padre.
const debeOcultarseComponente = (componente, visibilidadComponentes, componentesMap = {}, visitados = new Set()) => {
	const control = componente.condicional?.control;
	if (control === null || control === undefined || visitados.has(componente.key)) {
		return false;
	}
	visitados.add(componente.key);

	// Compatibilidad con formularios antiguos guardados antes de que existiera "accion": se comportaban como "show".
	const accion = componente.condicional?.accion || "show";
	const valorActual = visibilidadComponentes[control];
	const cumpleValor =
		valorActual !== undefined &&
		componente.condicional.valor
			.toLowerCase()
			.split("\n")
			.some((v) => v === valorActual.toLowerCase());

	if (accion === "show" && !cumpleValor) {
		return true;
	}
	if (accion === "hidden" && cumpleValor) {
		return true;
	}

	const componentePadre = componentesMap[control];
	if (componentePadre && debeOcultarseComponente(componentePadre, visibilidadComponentes, componentesMap, visitados)) {
		return true;
	}

	return false;
};